import { Control, Controller } from 'react-hook-form';
import { User } from '../../../../../types';
import { UserFormData } from '../../add-user-dialog/user-form-page';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import ExpandMore from '@mui/icons-material/ExpandMore';

interface NotesAccordionProps {
  control: Control<UserFormData>;
  user: User | null;
  disabled: boolean;
}

export default function NotesAccordion({
  control,
  disabled,
  user,
}: NotesAccordionProps) {
  return (
    <Accordion defaultExpanded={!!user?.notes && user.notes !== ''}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack flexDirection="row" alignItems="center" gap={1}>
          <Typography>Notes</Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 2 }}>
        <Stack
          gap={1}
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ my: 1.5 }}
        >
          <Controller
            name="notes"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                autoComplete="off"
                multiline
                rows={3}
                disabled={disabled}
              />
            )}
          />
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
